export default {
  fileUpload: {
    ATTACHMENTS: `Attachments`,
    ATTACHMENTS_COUNT: `{{ count }} attachment`,
    ATTACHMENTS_COUNT_other: `{{ count }} attachments`,
    DRAG_AND_DROP_FILE: `Drag a file or click to select a file to upload it`,
    INCORRECT_FILE_TYPE: `Incorrect file type`,
    OPEN_FILE: `Open attachment`,
    LOADING_FILE: `Loading attachments`,
    TOO_LARGE: `File is too large. Try a file smaller than 25MB`
  },
  REMOVE: `Remove`
}
